export const state = (): Experiments => ({
  experimentsData: new Map<string, any>()
})

export const GET_EXPERIMENTS_DATA = "getExperimentsData"

export const getters = {
  [GET_EXPERIMENTS_DATA]: (state: Experiments): Map<string, any> => state.experimentsData
}

export const _SET_EXPERIMENTS_DATA = "setExperimentsData"

export const mutations = {
  [_SET_EXPERIMENTS_DATA](state: Experiments, experimentData: Map<string, any>) {
    state.experimentsData = experimentData
  }
}

export const SET_EXPERIMENTS_DATA = "setExperimentsData"

export const actions = {
  [SET_EXPERIMENTS_DATA]({ commit }, experimentsData: Map<string, any>) {
    commit(_SET_EXPERIMENTS_DATA, experimentsData)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
